import { Injectable } from '@angular/core';
import {State, Action, StateContext, Selector} from '@ngxs/store';
import { selectedVitalsList } from './vitals.action';
 
 
export class selectedVitals{
    
    vitals:string[];
 
 }
 @State<selectedVitals>({
     name: 'selectedVitals',
     defaults: {
       
        vitals:[],
        
      }
 })
 @Injectable()
 export class VitalState {
 
     constructor( ) {
     }
 
     @Selector()
     static selectedVitals(state: selectedVitals) {
         return state;
     }
    

     @Action(selectedVitalsList)
     selectedVitalsList({getState, patchState}: StateContext<selectedVitals>, {payload}: selectedVitalsList) {
         const state = getState(); 
         patchState({
            vitals:payload
            });
     }
     
    } 